<template>
    <div>
        <limitless-page-header title="Ekonomi" :sub-title="'Kortskuld' + (year ? ' ' + (year-1) + '-09-01 - ' + year + '-08-31' : '')"></limitless-page-header>

        <div class="content">
            <i v-if="loading" class="icon-spinner2 spinner"></i>
            <div v-else-if="report" class="card">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Serie</th>
                                <th>Benämning</th>
                                <th class="text-right">Antal</th>
                                <th class="text-right">Snittpris Fsg</th>
                                <th class="text-right">Fsg pris</th>
                                <th class="text-right">Snittpris Inl</th>
                                <th class="text-right">Inlösenskostnad</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(row, r_index) in report.table"
                                :key="'row-' + r_index"
                            >
                                <td>{{ row.CardSeriesID }}</td>
                                <td>{{ row.SeriesName }}</td>
                                <td class="text-right">{{ formatNumber(row.debt_count, 0) }}</td>
                                <td class="text-right">{{ formatNumber(row.avg_price_sale, 2) }}:-</td>
                                <td class="text-right">{{ formatNumber((row.avg_price_sale * row.debt_count), 0) }}:-</td>
                                <td class="text-right">{{ formatNumber(row.avg_price_redeem, 2) }}:-</td>
                                <td class="text-right">{{ formatNumber(row.debt_value, 0) }}:-</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th></th>
                                <th></th>
                                <th class="text-right"> {{ formatNumber(report.totals.debt_count, 0) }}</th>
                                <th class="text-right"></th>
                                <th class="text-right"> {{ formatNumber(report.totals.sale_value, 0) }}:-</th>
                                <th class="text-right"></th>
                                <th class="text-right"> {{ formatNumber(report.totals.debt_value, 0) }}:-</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import apiClient from '@services/ApiClient';
import { formatNumber } from '@services/Helpers';

export default {
    components: {
        LimitlessPageHeader,
    },
    data: () => ({
        loading: false,
        year: '',
        report: null,
    }),
    mounted() {
        const today = new Date();
        this.year = today.getFullYear();
        if (today.getMonth() < 8) {
            this.year -= 1;
        }
        this.getData();
    },
    methods: {
        formatNumber,
        getData() {
            this.loading = true;
            apiClient.get('/vue/economy/report/card_debt/' + this.year)
                .then((response) => {
                    this.report = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};

</script>
